import { render } from "./StandupParticipants.vue?vue&type=template&id=2b599466&scoped=true"
import script from "./StandupParticipants.vue?vue&type=script&lang=js"
export * from "./StandupParticipants.vue?vue&type=script&lang=js"

import "./StandupParticipants.vue?vue&type=style&index=0&id=2b599466&scoped=true&lang=css"

import exportComponent from "/Users/peter/www/standup-timer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b599466"]])

export default __exports__